module.exports = __webpack_public_path__ + "img/stick_nature_sommets_plateaux.79fcda56.svg";